import { ICustomer } from "shared-types/index";

const NS = 'CustomerStateActions';

export enum CustomerStateActionNames {
  CUSTOMERS_CHANGE = 'customers-change', // no param
  CUSTOMER_UPDATED = 'customer-updated', // with evt, customer param
}

class CustomerStateActions {

  private $rootScope: any;

  public setup($rootScope: any): void {
    this.$rootScope = $rootScope;
  }

  customerStateAction(name: CustomerStateActionNames, payload?: ICustomer): void {
    this.$rootScope.$broadcast(name, payload);
  }

  customerChangeUpdateAction(payload: ICustomer = null): void {
    this.$rootScope.$broadcast(
      payload ? CustomerStateActionNames.CUSTOMER_UPDATED : CustomerStateActionNames.CUSTOMERS_CHANGE,
      payload
    );
  }

  handleCustomerStateAction(name: CustomerStateActionNames, callback: (evt?: any, payload?: ICustomer) => void): () => void {
    // returns the "unlisten" handler
    return this.$rootScope.$on(name, (evt?: any, payload?: ICustomer) => {
      callback(evt, payload);
    });
  }
}

// singleton
const instance = new CustomerStateActions();
export default instance as CustomerStateActions;
